/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import {
  MANDATE_EXCLUSIVE_SALE,
  MANDATE_SEASONAL_RENTAL,
  MANDATE_SIMPLE_SALE
} from '../../enums/MandateTypes.mjs'

export function useLeaseAmountLabel (type: MandateType) {
  const intl = useIntl()

  if (type === MANDATE_EXCLUSIVE_SALE || type === MANDATE_SIMPLE_SALE) {
    return intl.formatMessage({
      id: 'sale_price_including_fees_and_tax',
      defaultMessage: 'Prix de vente avec honoraires TTC'
    })
  }
  if (type === MANDATE_SEASONAL_RENTAL) {
    return intl.formatMessage({
      id: 'bed_night',
      defaultMessage: 'Nuitée'
    })
  }
  return intl.formatMessage({
    id: 'rent_excluding_charges',
    defaultMessage: 'Loyer hors charges'
  })
}
